<template>
    <section
        ref="section20"
        :class="[
            Object.keys(validationErrors).length > 0 ? 'has-errors' : '',
            'mx-auto flex h-full flex-col',
        ]"
    >
        <v-add-listing-head :routes="routes" :step="23"></v-add-listing-head>
        <main
            class="flex h-full flex-col items-center justify-between overflow-y-scroll px-4 py-8 md:px-12"
        >
    
            <figure class="relative flex max-w-3xl flex-col gap-11 lg:w-full">
                <figure class="ml-auto mr-auto flex w-full max-w-lg gap-3">
                    <div><v-icon icon="fire" size="8"></v-icon></div>
                    <div class="flex flex-col justify-center">
                        <div class="mb-3 mr-6 text-heading-3-desktop">
                            Kateri je glavni vir ogrevanja?
                        </div>
                        <div class="text-body-regular text-black-40">
                            Izberete lahko več možnosti.
                        </div>
                    </div>

                    <v-lightbox is-authenticated footerless>
                        <template v-slot:trigger>
                            <div
                                class="absolute right-0 top-0 flex h-8 w-8 cursor-pointer items-center justify-center rounded-full bg-white shadow hover:bg-green-25"
                            >
                                <v-icon icon="question-mark" size="4"></v-icon>
                            </div>
                        </template>
                        <template v-slot:head>
                            <div class="flex items-start">
                                <v-icon
                                    icon="question-mark"
                                    class="mr-2.5"
                                    size="4.5"
                                ></v-icon>
                                <div>
                                    Dodatne informacije
                                </div>
                            </div>
                        </template>
                        <template v-slot:content>
                            <p class="mb-[10px] text-icon-text-medium">
                                Vir ogrevanja
                            </p>
                            <p class="mb-8 text-body-regular">
                                Vir ogrevanja pomeni s katero energijo se greje vaša nepremičnina. Tukaj lahko izberete več možnosti, v primeru da se lahko nepremičnina ogreva na več različnih virov (npr. nepremičnina se lahko ogreva na olje in hkrati pelete).
                            </p>
                        </template>
                    </v-lightbox>
                </figure>
                <figure class="ml-auto mr-auto w-full max-w-lg">
                    <form method="POST" :action="routes.submitForm" id="select-heating-source">
                        <v-csrf-token></v-csrf-token>
                        <ul class="grid grid-cols-4 flex-col gap-x-5 gap-y-4">
                            <li
                                class="col-span-4"
                                v-for="(
                                    heatingSource, onOfficeEnum
                                ) in stepData.befeuerung_options"
                                :key="'heating-source-' + onOfficeEnum"
                            >
                                <v-checkbox
                                    :id="onOfficeEnum"
                                    :label="
                                        stepData.labels.befeuerung.values[
                                            onOfficeEnum
                                        ]
                                    "
                                    checkbox-position="right"
                                    :name="'befeuerung[' + onOfficeEnum + ']'"
                                    :value="onOfficeEnum"
                                    :icon="heatingSource.icon"
                                    :checked="
                                        stepData.befeuerung != null &&
                                        stepData.befeuerung[onOfficeEnum]
                                    "
                                    :class="[
                                        'checkbox group flex items-center',
                                        validationErrors.befeuerung
                                            ? 'has-errors'
                                            : '',
                                    ]"
                                    @vchanged="checkboxChanged"
                                ></v-checkbox>
                            </li>
                        </ul>
                    </form>
                </figure>
            </figure>
        </main>
        <v-add-listing-foot>
            <a
                @click="submitForm('select-heating-source')"
                :class="['button button--md h-[48px] w-[240px] px-6', (validated ? '' : 'button button--gray')]"
            >
                <label class="text-small-text-medium">Nadaljujte</label>
                <v-icon icon="arrow-right" size="4"></v-icon>
            </a>
        </v-add-listing-foot>
    </section>
</template>
<script>
import AddListingFootVue from "../AddListingFoot.vue";
import AddListingHeadVue from "../AddListingHead.vue";

export default {
    components: {
        "v-add-listing-foot": AddListingFootVue,
        "v-add-listing-head": AddListingHeadVue,
    },

    props: {
        old: {
            type: Object,
            required: false,
            default: {},
        },
        routes: {
            type: Object,
            required: true,
        },
        validationErrors: {
            type: Object,
            required: true,
            default: {},
        },
        stepData: {
            type: Object,
            required: true,
            default: {},
        },
    },

    data() {
        return {
            selectedOptions: [],
        };
    },
    mounted() {
        if(this.stepData.befeuerung != null) {
            this.selectedOptions = Object.values(this.stepData.befeuerung)  
        }
    },
    computed: {
        validated() {
            if(this.selectedOptions.length == 0) return false

            return true;
        }
    },
    methods: {
        checkboxChanged(value) {
            if(this.selectedOptions.includes(value)) {
                this.selectedOptions = this.selectedOptions.filter(val => val !== value)
            } else {
                this.selectedOptions.push(value)
            }
        },
        submitForm(formId) {
            if(this.validated) document.getElementById(formId).submit();
        },
    },
};
</script>
